import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class AppTranslationApplication extends CamLazyTranslationService {
  constructor() {
    super('merlin', true);
  }
}
